<template>
<md-list-item>
    <div class="md-list-text-container">
        <span><strong>{{collaborator.name}}</strong></span>
        <span>{{collaborator.role}}</span>
        <span>{{collaborator.email}}</span>
    </div>
    <md-list-expand v-if="editable">
        <md-button @click="removeCollaborator">
            <md-icon>delete</md-icon>
            Remove
        </md-button>
    </md-list-expand>
</md-list-item>
</template>

<script>

const CollaboratorsPendingCollaborator = {
    name: 'CollaboratorsPendingCollaborator',
    props: ['collaborator', 'editable', 'layers'],
    data: function() {
        return {
            editing: false
        };
    },
    methods: {
        removeCollaborator() {
            console.log(this.collaborator);
            this.$emit('removePendingCollaborator', this.collaborator.id);
        }
    }
};
export default CollaboratorsPendingCollaborator;
</script>

<style>
</style>


// WEBPACK FOOTER //
// pending-collaborator.vue?1f168b62